module.exports = __webpack_public_path__ + "img/check-full-circe.08acabe0.svg";